import { Component, Input } from '@angular/core';
import { NetzbetreiberDatenabfrage } from '../../domain/model/datenabfrage/netzbetreiber-datenabfrage';

@Component({
    selector: 'tnb-netzbetreiber-display-card',
    templateUrl: './netzbetreiber-display-card.component.html',
    styleUrls: [
        './netzbetreiber-display-card.component.scss',
    ],
    standalone: false,
})
export class NetzbetreiberDisplayCardComponent {

    @Input() netzbetreiber: NetzbetreiberDatenabfrage;

    constructor() {
    }
}
